import { isBrowser, noop, pickBy } from 'es-toolkit';
import { isEmpty, negate } from 'es-toolkit/compat';
import { AB_TEST_IDS } from '../../constants';
import { UnifiedEventsService } from './UnifiedEventsService';
import { formatEvent } from './utils';
export class TelemetryService extends UnifiedEventsService {
    #requestClient;
    #storeClient;
    constructor(requestClient, storeClient) {
        super(requestClient, storeClient);
        this.#requestClient = requestClient;
        this.#storeClient = storeClient;
    }
    #log(url, body) {
        const { partnerId, version, playerVersion, optionalParams } = this.#storeClient.options;
        const internalContext = pickBy({
            appEnv: isBrowser() ? 'client' : 'server',
            abTestIds: this.#storeClient.getConfigSetting(AB_TEST_IDS),
            partnerId: body.context?.partnerId || partnerId,
            appVersion: version,
            playerVersion,
            desktopVersion: optionalParams?.desktopVersion,
            error: body.context?.error instanceof Error ? body.context.error.message : body.context?.error,
        }, negate(isEmpty));
        body.context = Object.assign(body.context || {}, internalContext);
        return this.#requestClient.fetch({ url, post: body }).catch(noop);
    }
    logInfo(body) {
        const { logs } = this.#storeClient.options.domains;
        return this.#log(`${logs}/info/`, body);
    }
    logError(body) {
        const { logs } = this.#storeClient.options.domains;
        return this.#log(`${logs}/error/`, body);
    }
    reportEvent(options) {
        const { event, body, params } = options;
        const { opml } = this.#storeClient.options.domains;
        return this.#requestClient.fetch({
            method: event || body ? 'POST' : 'GET',
            url: `${opml}/Report.ashx`,
            params: {
                ...(event && { c: 'eventlist' }),
                ...params,
            },
            ...(event && {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
                body: formatEvent(event),
            }),
            ...(body && { post: body }),
            retries: 0,
        });
    }
}
